import { ReactNode } from 'react'

export interface ResourceCard {
  number: number
  title: string
  content: ReactNode
}

export const resourceCards: ResourceCard[] = [
  {
    number: 1,
    title: 'Insights Gathering',
    content: (
      <div className="flex flex-col gap-2">
        <p>
          <b>Curate</b> existing data. If you feel you have enough knowledge to proceed after this, do so.
        </p>
        <p>
          If not, commission new research with partners to fill gaps, making careful consideration to use some/all of
          the <b>5 Human Disciplines</b> (Psychology, Sociology, Anthropology, Economics, & Neuroscience) in your
          approach.
        </p>
      </div>
    ),
  },
  {
    number: 2,
    title: 'Team Connects',
    content: (
      <div className="flex flex-col gap-2">
        <p>
          <b>Team exchanges & cross pollinations</b> at critical milestones.
        </p>
        <p>
          <b>Example flow:</b>
          <br />
          30' presentations
          <br />
          50' Q&A and discussion
          <br />
          10' next steps
        </p>
      </div>
    ),
  },
  {
    number: 3,
    title: "Team Members' Immersion Homework",
    content: (
      <>
        <ul className="insights-bullets">
          <li>Onboarding to existing knowledge (pre-reads)</li>
          <li>Connect with experts</li>
          <li>Observations / empathy journeys</li>
          <li>Consumer connects</li>
        </ul>
        <p className="font-bold">
          For more guidance refer back to the{' '}
          <a
            href="https://onedrive.coca-cola.com/:f:/g/personal/skuper_coca-cola_com1/Er8PYxYAw2dKunujRPjb9kMBcV2YXOpZFmOVR8BSKoz8IQ?e=CJ3Pdo"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Immersion Playbook
          </a>
        </p>
      </>
    ),
  },
]

export interface OutputObjectiveItem {
  number: number
  text: string
}

export const outputObjectiveItems: OutputObjectiveItem[] = [
  {
    number: 1,
    text: 'Get entire core team aligned on basic facts and new news across all three parts (People, Product, Brand)',
  },
  {
    number: 2,
    text: 'Discover unexpected truths that go beyond surface observations and reframe the problem in a way that sparks new opportunities and creative action',
  },
]

export interface DataSourceCategory {
  label: string
  bullets: string[]
}

export interface DataSourceColumn {
  key: 'people' | 'product' | 'brand'
  title: string
  categories: DataSourceCategory[]
}

export const dataSourceColumns: DataSourceColumn[] = [
  {
    key: 'people',
    title: 'People',
    categories: [
      {
        label: 'Growth Audience',
        bullets: ['BEACH', 'Need-state deep dive', 'Demand spaces', 'Audience Origin', 'PRISM', 'Consumer flows'],
      },
      {
        label: 'Design Audience',
        bullets: ['Psychographic lens', 'Frontend research', 'Successful past communications'],
      },
      {
        label: 'Design Audience Empathy',
        bullets: ['Ad hoc qualitative research (e.g. consumer immersions, Mind Maps, social listening)'],
      },
    ],
  },
  {
    key: 'product',
    title: 'Product',
    categories: [
      {
        label: "People's Needs + Expectations",
        bullets: ['Need-state deep dive', 'Frontend research', 'Signature experience (eg. Mind Maps)'],
      },
      {
        label: 'Role of the Category',
        bullets: [
          'U&A',
          'Product experience testing',
          'R&D frontend research',
          'R&D sensory mapping & category knowledge',
          'Future trends in Innovation',
        ],
      },
      {
        label: 'Our Uniqueness + Superiority',
        bullets: ['Taste Superiority Tracker', 'Product strength', 'Competitive review', 'Evolving portfolios'],
      },
    ],
  },
  {
    key: 'brand',
    title: 'Brand',
    categories: [
      {
        label: 'Brand Assets',
        bullets: [
          'VIS',
          'Brand comms',
          'Design archives',
          'Semiotics',
          'Competitive review (eg. MoT comms)',
          'Creative strategy',
          'Distinctive Asset Testing',
          'Signature experience',
        ],
      },
      {
        label: 'Brand Power',
        bullets: ['BEACH equity', 'Brand Power', 'Psychographic & brand reports'],
      },
      {
        label: 'Hero Occasions',
        bullets: ['U&A', 'Asset review', 'Business & system reviews'],
      },
    ],
  },
]
